<script setup>
import {defineProps} from 'vue'

defineProps({
  withoutIcon: {
    type: Boolean,
    default: false,
  },
})
</script>

<template>
  <div class="alert-message-info">
    <div class="pe-2 icon" v-if="!withoutIcon">
      <img src="~@shared-images/icons/info-icon.svg" alt="info" />
    </div>
    <div>
      <slot />
    </div>
  </div>
</template>
